








import Vue from 'vue'

export default Vue.extend({
  name: 'Block',
  props: {
    slug: {
      type: String,
    },
  },
  mounted() {
    this.$api
      .get('/articles/slug/' + this.slug)
      .then((response) => (this.article = response.data))
  },
  data: () => ({
    article: null,
  }),
})
